import {
  InfoModule,
  createInfoServices
} from "./chunk-FRFDVMJY.mjs";
import "./chunk-TCCFYFTB.mjs";
export {
  InfoModule,
  createInfoServices
};
